<template>
  <div class="bg-secondary text-white text-xs p-3 xl:p-5 leading-7 font-bold xl:text-base">
    <div class="grid grid-cols-bannerOpenHouse gap-5">
      <div class="uppercase">
        <font-awesome-icon :icon="['fas', 'home']" />
        Open House:
      </div>
      <div class="xl:hidden">
        <div v-if="collapsed">
          {{ soonestStartTime }}
        </div>
        <ul v-else>
          <li
            v-for="(startTime, i) in startTimes"
            :key="i"
          >
            {{ startTime }}
          </li>
        </ul>
      </div>
      <div class="hidden xl:block">
        <ul>
          <li
            v-for="(startTime,i) in startTimes"
            :key="i"
            class="inline-block"
          >
            {{ startTime }}
            <span
              v-if="i !== startTimes.length - 1"
              aria-hidden="true"
            >
              &nbsp;|&nbsp;
            </span>
          </li>
        </ul>
      </div>
      <div
        v-if="startTimes.length > 1"
        class="xl:hidden"
      >
        <BorderBtn @click="handleViewMoreClicked">
          {{ collapsed ? 'View More' : 'View Less' }}
        </BorderBtn>
      </div>
    </div>
  </div>
</template>

<script>
import { faHome } from '@fortawesome/free-solid-svg-icons/faHome';
import { library } from '@fortawesome/fontawesome-svg-core';
import BorderBtn from '../BorderBtn.vue';
import { formatFullDate } from '../../../../helpers/formatDate';

export default {
  name: 'BannerOpenHouse',
  components: { BorderBtn },
  props: {
    openHouses: {
      required: true,
      type: Object,
    },
  },
  data() {
    return {
      collapsed: true,
    };
  },
  computed: {
    soonestStartTime() {
      const [firstStartTime] = this.startTimes;
      return firstStartTime;
    },
    startTimes() {
      return this.openHouses
        .map((openHouse) => {
          const { open_house_start_time: startTime } = openHouse;
          return new Date(startTime);
        })
        .sort((a, b) => a - b)
        .map((date) => formatFullDate(date))
        .slice(0, 5);
    },
  },
  created() {
    library.add(faHome);
  },
  methods: {
    handleViewMoreClicked() {
      this.collapsed = !this.collapsed;
    },
  },
};
</script>
